/*
 * @Author: codesides
 * @Descripttion:
 * @Date: 2024-10-17 14:43:35
 * @LastEditors: codesides
 * @LastEditTime: 2024-11-08 16:37:51
 * @FilePath: \lesson-pc\src\utils\interceptorKhfw.js
 */
// import { version } from "./config";
import axios from "axios";
import { message } from "ant-design-vue";
import { toLogin, navigateTo } from "./common";
import Cookies from "js-cookie";
import router from "@/router";
import { DB_MASTER_DELAY } from "./config"

const version = "2024.05.27 16:24";
const _axios = axios.create({
  baseURL: "/khfw-api",
  timeout: 60000,
});
// 添加请求拦截器
_axios.interceptors.request.use(
  (config) => {
    const XAccessToken = Cookies.get("X-Access-Token");
    if (XAccessToken) {
      config.headers["X-Access-Token"] = XAccessToken;
    }
    const Authorization = Cookies.get("Authorization");
    if (Authorization) {
      config.headers["Authorization"] = Authorization;
    }
    const dbMaster = Cookies.get('dbMaster')
    if(dbMaster){
      config.headers["DB-MASTER"] = dbMaster;
    }
    config.headers.Version = version;
    return config;
  },
  (error) => {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);
// 添加响应拦截器
_axios.interceptors.response.use(
  async (response) => {
    // 对响应数据做点什么
    let { code, message: msg } = response.data;
    // 响应如果是blob二进制流数据，如果内容大于0，直接给2000状态码进入正常逻辑
    // if (response.request.responseType === "blob") {
    //   code = 2000;
    // }
    if (response.request.responseType === "blob") {
      const fielName =
        response.headers["meal-file-export"] ||
        response.headers["Meal-File-Export"] ||
        response.headers["tuition-file-export"];
      const exportMsg =
        response.headers["meal-verify-msg"] ||
        response.headers["Meal-Verify-Msg"] ||
        response.headers["tuition-verify-msg"];
      if (!fielName) {
        const dsp = response.headers["content-disposition"];
        const ct = response.headers["content-type"];
        const tIdx = dsp ? dsp.indexOf("filename=") : -1;
        const tTyp = ct.indexOf("application/json;");
        if (tIdx === -1) {
          code = 4000;
          return Promise.reject(response.data);
        } else if (tTyp !== -1) {
          code = 9999;
        } else {
          code = 200;
          msg = "导出成功";
          response.data.fielName = dsp.slice(tIdx + 9);
        }
      } else {
        code = 200;
        msg = "导出成功";
        response.data.fielName = fielName;
      }
    }
    switch (code) {
      case 1:
      case 200:
        if(response.headers['db-master']){
          Cookies.set("dbMaster", response.headers['db-master'], { expires: new Date(Date.now() + DB_MASTER_DELAY) });
        }
        return response.data;
      case 404:
      // 500服务器错误
      case 500:
      case 502:
      case 510:
      // 5000服务器报错
      case 5000:
        message.error({ content: msg, key: "netMsg", duration: 2 });
        return Promise.reject(response.data);
      // 9000 无权限
      case 9000:
        message.error({ content: "暂无权限", key: "netMsg", duration: 2 });
        navigateTo("/unauthorized", "_replace", 1);
        return Promise.reject(response.data);
      // 9001 用户未授权或授权过期
      case 9001:
      case 10000:
        message
          .error({
            content: "用户未授权或授权过期",
            key: "netMsg",
            duration: 2,
          })
          .then(() => {
            toLogin();
          });
        return Promise.reject(response.data);
      case 9002:
        message
          .error({
            content: "用户角色身份错误，请重新登录!",
            key: "netMsg",
            duration: 2,
          })
          .then(() => {
            toLogin();
          });
        return Promise.reject(response.data);
      case 9999:
        return Promise.reject(response.data);
      case 401:
        router.replace("/home");
        Cookies.remove("X-Access-Token");
        Cookies.remove("Authorization");
        return Promise.reject(response.data);
      default:
        message.error({ content: msg, key: "netMsg", duration: 2 });
        return Promise.reject(response.data);
    }
  },
  (error) => {
    // 对响应错误做点什么
    return Promise.reject(error);
  }
);

export default _axios;
